import Lenis from 'lenis'

// Initialize Lenis
const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
  direction: "vertical",
  gestureDirection: "vertical",
  smooth: true,
  smoothTouch: false,
  touchMultiplier: 2,

  // Prevent scroll inside offcanvas
  prevent: (node) => {
    return node.closest('.offcanvas')
  }
})

// RAF loop
function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)


// ---------------------------------------------
// Smooth scroll to #footerContact (click)
// ---------------------------------------------
document.querySelectorAll('a[href="#footerContact"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault()

    const target = document.querySelector('#footerContact')
    if (target) {
      lenis.scrollTo(target)
    }
  })
})


// ---------------------------------------------
// Scroll to #results on page load (if present)
// ---------------------------------------------
window.addEventListener('load', () => {
  if (window.location.hash !== '#results') return

  const target = document.getElementById('results')
  if (!target) return

  // Wait one frame so layout is fully calculated
  requestAnimationFrame(() => {
    lenis.scrollTo(target, {
      duration: 1.2,
      offset: 0,
    })
  })
})
